import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from "@angular/fire/firestore";
import { environment } from "../../environments/environment";
import { convertTimestamp } from "../@core/utils/convertTimestamps.service";
import Profile from "../models/profile.model";

@Injectable()
export class ProfileService {
  baseUrl = environment.apiUrl;
  schoolId = environment.schoolId;
  private dbPath = "/profiles";
  profileRef: AngularFirestoreCollection<Profile>;

  constructor(private db: AngularFirestore, private http: HttpClient) {
    this.profileRef = db.collection(this.dbPath);
  }

  get(id: string) {
    return this.profileRef.doc(id).valueChanges();
  }

  getUserByEmail(email?: string): AngularFirestoreCollection<Profile> {
    return this.db.collection("/users", (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("email", "==", email)
        // .orderBy("updatedOn", "desc")
        .limit(1)
    );
  }

  create(uid, email, displayName) {
    const userRef: AngularFirestoreDocument<any> = this.db.doc(
      `profiles/${uid}`
    );
    const profileData: Profile = {
      uid: uid,
      email: email,
      displayName: displayName,
      photoURL:
        "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/Profile/default_avatar.jpg",
      schoolId: this.schoolId,
      isActive: true,
      isDeleted: false,
    };
    userRef.set(profileData, {
      merge: true,
    });

    //Sync user to local
    profileData.fsId = uid;
    this.syncPerson(profileData);
  }

  update(id: string, data: Profile): Promise<void> {
    const updatedOn = new Date();

    return this.profileRef
      .doc(id)
      .update({
        displayName: data.displayName ? data.displayName : "user",
        fullName: data.fullName ? data.fullName : "",
        firstName: data.firstName ? data.firstName : "",
        lastName: data.lastName ? data.lastName : "",
        dob: data.dob ? data.dob : new Date(),
        gender: data.gender ? data.gender : 2,
        mobile: data.mobile ? data.mobile : "",
        address: data.address ? data.address : "",
        facebook: data.facebook ? data.facebook : "",
        instagram: data.instagram ? data.instagram : "",
        youtube: data.youtube ? data.youtube : "",
        twitter: data.twitter ? data.twitter : "",
        website: data.website ? data.website : "",
        updatedOn: updatedOn,
        timestamp: new Date().getTime(),
      })
      .then((docRef) => {
        //Sync user to local
        data.fsId = id;
        this.syncPerson(data);

        return docRef;
      });
  }

  updateAvatar(id: string, photoURL: string): Promise<void> {
    const updatedOn = new Date();
    return this.profileRef.doc(id).update({
      photoURL: photoURL,
      updatedOn: updatedOn,
      timestamp: new Date().getTime(),
    });
  }

  private syncPerson(user) {
    if (user.dob) {
      user.dob = convertTimestamp(user.dob);
    }
    this.http.post(this.baseUrl + "/Persons", user).subscribe({
      next: () => {},
      error: (err) => {},
    });
  }
}
